import { LayoutMenuItems } from '@webV2/providers/LayoutProvider/types';
import { WebRoutes } from '@webV2/defines/routes';
import { DashboardIconAnimated } from '@cmp-src/icons/TacticIcons/DashboardIconAnimated';
import { MapIconAnimated } from '@cmp-src/icons/TacticIcons/MapIconAnimated';
import { SidebarChartAnimated } from '@cmp-src/icons/TacticIcons/SidebarChartAnimated';
import { SuitcaseIconAnimated } from '@cmp-src/icons/TacticIcons/SuitcaseIconAnimated';
import { UserIconAnimated } from '@cmp-src/icons/TacticIcons/UserIconAnimated';
import { Permissions } from '@gettactic/api';

const ICON_SIZE = 26;

export const DEFAULT_MAIN_MENU_ITEMS: LayoutMenuItems = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    url: WebRoutes.dashboard,
    icon: (props: { isActive?: boolean }) => (
      <DashboardIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true
  },
  {
    id: 'map',
    title: 'Map',
    url: WebRoutes.map,
    icon: (props: { isActive?: boolean }) => (
      <MapIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true,
    appendFloorId: true
  },
  {
    id: 'gantt',
    title: 'Schedules',
    url: WebRoutes.gantt,
    icon: (props: { isActive?: boolean }) => (
      <SidebarChartAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true
  },
  {
    id: 'reports',
    title: 'Reports',
    url: WebRoutes.reports,
    icon: (props: { isActive?: boolean }) => (
      <SuitcaseIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: (permissions: Permissions) => !!permissions?.settings
  },
  {
    id: 'directory',
    title: 'Directory',
    url: WebRoutes.directory,
    icon: (props: { isActive?: boolean }) => (
      <UserIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true
  }
];
